import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';

// Shape inferred from ./test.json
export interface VarBacktestApiResponse {
  'holding period factor': number;
  fails: number;
  diff_data: any[][];
  sides: string;
  var_approach: string;
  historical_data: any[][];
  'confidence interval': number;
  cis_time_series: any[][];
  base_currency: string;
  var_fund: string;
  raptor_diff_data: any[][];
  'holding period': number;
  exceedance_data: any[][];

  // Current optional keys only exist for FIL funds.
  // When not existing hardcoding on frontend remains for now.
  status?: 'Pass' | 'Fail' | 'Alert';
  'max exceedances'?: number;
}

export const fetchVarBacktestData = async (
  fundId: string,
  startDate: string,
  endDate: string,
): Promise<VarBacktestApiResponse> => {
  const url = `ucits_historical_backtest/${fundId}/${startDate}/${endDate}`;

  const response = await AxiosInstance.get<VarBacktestApiResponse>(url);

  return response.data;
};

export function useVarBacktestQuery(
  fundId: string | undefined,
  startDate: string | null,
  endDate: string | null,
) {
  return useQuery({
    queryKey: ['var-backtest', fundId, startDate, endDate],
    queryFn: () =>
      fetchVarBacktestData(
        fundId as string,
        startDate as string,
        endDate as string,
      ),
    enabled: !!fundId && !!startDate && !!endDate,
    staleTime: 60 * 60 * 1000,
  });
}
